import styled from 'styled-components';
import Color from 'color';
import { cashColor, redColor } from 'pages/Logs/components/LogTable.styled';
import { lFColor0 } from 'pages/components/LFHeader/LFHeader.styled';

// Daily above 0 uses the former Total blue; Total green pairs with that blue
export const areaDailyGreen = lFColor0;
export const areaTotalGreen = '#82ca9d';
export const areaDailyRed = Color(redColor).lighten(0.18).toString();
export const areaTotalRed = Color(redColor).darken(0.22).toString();

export const getAreaSeriesColor = (dataKey: string, value: number) => {
  const isDaily = dataKey === 'daily';
  if (value < 0) {
    return isDaily ? areaDailyRed : areaTotalRed;
  }
  // Tooltip accents keep profit/cash green; chart fills use area*Green above
  return isDaily ? areaDailyGreen : cashColor;
};

export const Container = styled.div<any>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
